import { render, staticRenderFns } from "./SurveyPoint.vue?vue&type=template&id=38129f32&scoped=true"
import script from "./SurveyPoint.vue?vue&type=script&lang=js"
export * from "./SurveyPoint.vue?vue&type=script&lang=js"
import style0 from "./SurveyPoint.vue?vue&type=style&index=0&id=38129f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38129f32",
  null
  
)

export default component.exports